import React from 'react';
import ReactDOM from 'react-dom';
import RequestPanel from './RequestPanel';
import IssuePanel from './IssuePanel';

// Determine mode
const url = new URL(window.location);
const queryStringParameters = new URLSearchParams(url.search);
const container = document.querySelector('#container');

switch (queryStringParameters.get('mode')) {

  case "panel":
    ReactDOM.render(<RequestPanel />, container);
    break;

  case "issue":
    ReactDOM.render(<IssuePanel />, container);
    break;

  default:
    throw new Error("Unknown mode selected");
}